import { Environment } from '../../types/Environment';

export const sentryConfig = {
  dsn: 'https://1a29cb3abbc3402cb56af3c3b427a549@sentry.wixpress.com/1710',
  environment: process.env.NODE_ENV === 'production' ? Environment.Prod : Environment.Dev,
};
